import { AppBar, Box, Tab, Tabs } from "@mui/material"
import { TabPanel } from "components/TabPanel/TabPanel"
import { SyntheticEvent, useState } from "react"
import { CommunicationTab } from "./CommunicationTab"
import { AudittrailTab } from "./AudittrailTab"
import { EUTGroupTab } from "./EUTGroupTab"
import { DeviceEutGroup } from "graphql/types"

type EUTManagmenentRightBoxProps = {
  eut: DeviceEutGroup
  onSave: (arg: DeviceEutGroup) => void
}

export const EUTManagementRightBox = (props: EUTManagmenentRightBoxProps) => {
  const { eut, onSave } = props
  const [value, setValue] = useState(0)

  const handleChange = (_: SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  return (
    <Box
      sx={{
        flex: 1,
        border: "solid grey",
        borderWidth: "0 4px 0 4px",
        height: "100vh",
        overflow: "auto",
      }}
    >
      <AppBar position="static">
        <Tabs value={value} onChange={handleChange} variant="fullWidth">
          <Tab label="Kommunikation" />
          <Tab label="AuditTrail" />
          <Tab label="EUT-Gruppe" />
        </Tabs>
      </AppBar>

      <TabPanel value={value} index={0}>
        <CommunicationTab />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <AudittrailTab />
      </TabPanel>
      <TabPanel value={value} index={2}>
        {eut && <EUTGroupTab eut={eut} onSave={onSave} />}
      </TabPanel>
    </Box>
  )
}
